import {sanitize} from 'dompurify';

export function parseTextFromHTML(html: string) {
  const tempDivElement = document.createElement('div');

  tempDivElement.innerHTML = sanitize(html);

  return tempDivElement.textContent || tempDivElement.innerText || '';
}
